var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-result-wrap"},[_c('img',{staticClass:"no-result-icon",attrs:{"src":require('assets/common/tip.png'),"alt":""}}),_c('div',{staticClass:"no-result",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.tipText || _vm.$t('result_no_record'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }